<template>
  <div class="localization-view">
    <h2 class="title">{{$t('localization.title')}}</h2>
    <div class="search" v-if="salons.length > 0">
      <span>{{$t('localization.city')}}</span>
      <input :placeholder="$t('localization.search')" type="text" v-model="search"/>
    </div>
    <div class="container" v-if="salons.length > 0 && loaded">
      <h3>{{$t('localization.map')}}</h3>
      <Map :center="currentCenter" :key="componentKey" :salons="filteredSalons" :zoom="zoom" :bounds="bounds"></Map>
    </div>
    <h3 v-else-if="loaded">{{ $t('home.no-salons')}}</h3>
    <Preloader v-else></Preloader>
    <h3 v-if="salons.length > 0">{{$t('localization.searchResults')}}</h3>
    <div class="salons-list-container" v-if="salons.length > 0">

      <SalonLocalization :key="salon.id" :salon="salon" @changeMap="moveMap"
                         v-for="salon in filteredSalons"></SalonLocalization>
    </div>
  </div>
</template>

<script>
import Map from '@/components/maps/Map.vue';
import SalonLocalization from '@/components/maps/SalonLocalization';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import Preloader from '@/components/helpers/Preloader';

const SalonsRepository = RepositoryFactory.get('salons');

export default {
  name: 'Localization',
  components: {
    Preloader,
    SalonLocalization,
    Map,
  },
  watch: {
    async groupId(newValue) {
      await this.getSalons(newValue);
    },
  },
  data() {
    return {
      zoom: 7,
      currentCenter: {
        lat: 53,
        lng: 19,
      },
      search: '',
      componentKey: 0,
      salons: [],
      loaded: false,
      bounds: [],
    };
  },
  async mounted() {
    await this.getSalons(this.$store.getters.selectedGroup.id);
  },
  computed: {
    groupId() {
      return this.$store.getters.selectedGroup.id;
    },
    filteredSalons() {
      const { salons } = this;
      salons.forEach(((value, key) => {
        if (!(value.city) || !(value.name)) {
          salons.splice(key, 1);
        }
      }));

      return this.salons.filter(salon => (salon.city !== null && salon.city.toLowerCase().includes((this.search.toLowerCase()))));
    },
    zoomLevel() {
      return this.zoom;
    },
  },
  methods: {
    async getSalons(groupId) {
      this.loaded = false;
      try {
        this.salons = await SalonsRepository.getLocations(this.$store.getters.token, groupId);
        if (this.salons.length > 1) {
          this.bounds = [
            [this.getMaxY(this.salons), this.getMinX(this.salons)],
            [this.getMinY(this.salons), this.getMaxX(this.salons)],
          ];
          this.getZoomLevel(
            Math.abs(this.getMinY(this.salons) - this.getMaxY(this.salons)),
            Math.abs(this.getMinX(this.salons) - this.getMaxX(this.salons)),
          );
        } else {
          this.currentCenter = {
            lat: this.salons[0].latitude,
            lng: this.salons[0].longitude,
          };
          this.zoom = 11;
        }
      } catch (error) {
        console.log(error);
      }
      this.forceRerender();
      this.loaded = true;
    },
    getMinY(salons) {
      return salons.reduce((min, p) => (p.latitude < min ? p.latitude : min), salons[0].latitude);
    },
    getMaxY(salons) {
      return salons.reduce((max, p) => (p.latitude > max ? p.latitude : max), salons[0].latitude);
    },
    getMinX(salons) {
      return salons.reduce((min, p) => (p.longitude < min ? p.longitude : min), salons[0].longitude);
    },
    getMaxX(salons) {
      return salons.reduce((max, p) => (p.longitude > max ? p.longitude : max), salons[0].longitude);
    },
    getZoomLevel(deltaLat, deltaLong) {
      this.currentCenter = {
        lat: deltaLat / 2,
        lng: deltaLong / 2,
      };
      if (deltaLat === 0 && deltaLong === 0) {
        this.zoom = 11;
      } else {
        const zoomY = Math.floor(360 / deltaLong);
        const zoomX = Math.floor(360 / deltaLat);
        let zoom = Math.min(zoomX, zoomY) - 1;
        if (zoom < 0) {
          zoom = 0;
        }
        this.zoom = zoom;
      }
    },
    moveMap(coordinates) {
      this.zoom = 13;
      this.currentCenter = coordinates;
      this.forceRerender();
    },
    forceRerender() {
      this.componentKey += 1;
    },
  },
};
</script>

<style lang="scss">


  h3 {
    text-align: left;
    text-transform: uppercase;
    margin-top: 100px;
    padding-left: 30px;
    font-weight: 900;
  }

  .search {
    font-weight: bold;
    font-size: rem(15px);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 20px;
    align-items: flex-start;
    width: 611px;
    @include media('<750px') {
      width: 100%;
    }

    input {
      border: 1px solid #e5e5e5;
      width: 100%;
      box-sizing: border-box;
      padding: 20px 40px;
      border-radius: 5px;
      /*margin-left: auto;*/
      margin-top: 11px;

    }
  }

  .localization-view {
    /*width: 1510px;*/
    margin: 0 auto;
  }

  .container {
    width: 100%;
    height: 700px;
    position: relative;
    z-index: 0;
    border-radius: 5px;
    background-color: white;
    padding-top: 35px;

    h3 {
      text-align: left;
      text-transform: uppercase;
      margin: 0;
      margin-bottom: 35px;
      padding-left: 30px;
      font-weight: 900;
    }

    .map-container {
      width: 100%;
      height: 100%;
    }

  }

  .salons-list-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    @include media('<750px') {
      flex-direction: column;
      align-items: center;
    }
  }

</style>
